export const useInvestmentsCount = (
  accounts?: { activeAssets?: number; id: number }[],
  depotIds?: number[]
) => {
  if (!accounts || !depotIds) return 0;
  const depots = accounts.filter(({ id }) => depotIds.includes(id));
  const investments = depots.reduce(
    (sum, { activeAssets }) => sum + (activeAssets || 0),
    0
  );
  return investments;
};
